import React from 'react'

type SelectOption = {
  value: string
  label: string
}

type SelectComponentProps = {
  labelText: string
  isRequired?: boolean
  options: SelectOption[]
  helpText?: string
  required?: boolean
  selectProps?: React.SelectHTMLAttributes<HTMLSelectElement>
  placeholder?: string
  value?: string
  onChange?: React.ChangeEventHandler<HTMLSelectElement>
}

export function Select({
  labelText,
  isRequired = false,
  options,
  helpText = '',
  required = false,
  selectProps = {},
  placeholder = '選択してください',
  value = '',
  onChange = () => {},
}: SelectComponentProps) {
  return (
    <label className="sq-label w-full" htmlFor={selectProps.id}>
      <div className="sq-label-box">
        <span className="sq-label-text">{labelText}</span>
        {isRequired && <span className="sq-label-required">必須</span>}
      </div>
      <div className="sq-select-box">
        <select
          className="sq-select"
          required={required}
          value={value}
          onChange={onChange}
          {...selectProps}
        >
          <option value="" disabled>
            {placeholder}
          </option>
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>
      {helpText && (
        <div className="sq-label-help-text sq-label-success">{helpText}</div>
      )}
    </label>
  )
}
